import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import jwt_decode from 'jwt-decode';
import { updateHeaderAuthorizationToken } from '../../../api';
import AuthService from '../../../services/auth.service';
import TokenService from '../../../services/token.service';
import { authenticateWallet, connectWallet, refreshToken } from '../Wallet/slice';
export const login = createAsyncThunk('auth/login', async (attr) => {
    try {
        return await AuthService.login(attr);
    }
    catch (err) {
        return err.response;
    }
});
export const googleLogin = createAsyncThunk('auth/google', async (token) => {
    try {
        return await AuthService.googleAuth(token);
    }
    catch (err) {
        return err.response;
    }
});
export const discordLogin = createAsyncThunk('auth/discord', async (token) => {
    try {
        return await AuthService.discordAuth(token);
    }
    catch (err) {
        return err.response;
    }
});
const setTokens = (state, tokens) => {
    const { accessToken, refreshToken } = tokens;
    TokenService.setWalletTokens(accessToken, refreshToken);
    TokenService.setTokens(accessToken, refreshToken);
    state.token = accessToken;
    state.refresh = refreshToken;
    state.loggedIn = true;
    state.pending = false;
    updateHeaderAuthorizationToken(accessToken);
};
export const initialState = {
    pending: false,
    loggedIn: false,
    error: null,
    user: null,
    notMatchStakeId: false,
    token: TokenService.getWalletAccessToken(),
    refresh: TokenService.getWalletRefreshToken()
};
export const authSlice = createSlice({
    name: 'auth',
    initialState,
    reducers: {
        logout: (state) => {
            state.loggedIn = false;
            TokenService.flush();
            updateHeaderAuthorizationToken('');
        },
        clearError: (state) => {
            state.error = null;
        },
        setAccessToken: (state, action) => {
            state.token = action.payload;
        }
    },
    extraReducers: (builder) => {
        builder.addCase(login.fulfilled, (state, action) => {
            state.pending = false;
            if (action.payload.status === 200) {
                setTokens(state, action.payload.data);
                state.user = {};
            }
            if (action.payload.status === 404) {
                state.error = action.payload.data.error;
            }
            if (action.payload.status === 400) {
                state.error = action.payload.statusText;
                state.user = null;
            }
        });
        builder.addCase(login.pending, (state) => {
            state.pending = true;
        });
        builder.addCase(login.rejected, (state) => {
            state.pending = false;
            state.loggedIn = false;
        });
        builder.addCase(googleLogin.fulfilled, (state, action) => {
            state.token = action.payload;
            if (action.payload.status === 200) {
                setTokens(state, action.payload.data);
                state.user = {};
            }
        });
        builder.addCase(googleLogin.pending, (state) => {
            state.pending = false;
        });
        builder.addCase(googleLogin.rejected, (state) => {
            state.pending = false;
            state.loggedIn = false;
        });
        builder.addCase(discordLogin.fulfilled, (state, action) => {
            state.token = action.payload;
            if (action.payload.status === 200) {
                setTokens(state, action.payload.data);
                state.user = {};
            }
        });
        builder.addCase(discordLogin.pending, (state) => {
            state.pending = false;
        });
        builder.addCase(discordLogin.rejected, (state) => {
            state.pending = false;
            state.loggedIn = false;
        });
        builder.addCase(connectWallet.fulfilled, (state, action) => {
            const walletInfo = action.payload.data;
            const decodedToken = jwt_decode(state.token);
            state.notMatchStakeId = decodedToken.stakeId !== walletInfo.stakeId;
            state.loggedIn = true;
        });
        builder.addCase(connectWallet.rejected, (state) => {
            state.loggedIn = false;
            state.notMatchStakeId = false;
        });
        builder.addCase(authenticateWallet.fulfilled, (state, action) => {
            state.notMatchStakeId = false;
            if (action.payload) {
                setTokens(state, action.payload);
                state.token = action.payload.accessToken;
            }
            else {
                state.token = '';
            }
        });
        builder.addCase(refreshToken.fulfilled, (state, action) => {
            if (action.payload) {
                setTokens(state, action.payload);
            }
        });
    }
});
export const { logout, clearError, setAccessToken } = authSlice.actions;
export default authSlice.reducer;
